import { c as _c } from "react/compiler-runtime";
import { RegularButton } from "@/components/Button/RegularButton/RegularButton.component";
import { Translation } from "@/components/Translation/Translation.component";
type CommentFormActionsProps = {
  readonly isPending: boolean;
  readonly isAtLimit: boolean;
  readonly isReply: boolean;
  readonly onCancel?: () => void;
};
export function CommentFormActions(t0) {
  const $ = _c(12);
  const {
    isPending,
    isAtLimit,
    isReply,
    onCancel
  } = t0;
  const t1 = isPending || isAtLimit;
  let t2;
  if ($[0] !== isPending || $[1] !== isReply) {
    t2 = isPending ? <Translation da="Sender..." de="Senden..." en="Posting..." no="Sender..." sv="Skickar..." /> : <Translation da={isReply ? "Svar" : "Komment\xE9r"} de={isReply ? "Antworten" : "Kommentieren"} en={isReply ? "Reply" : "Post comment"} no={isReply ? "Svar" : "Kommenter"} sv={isReply ? "Svara" : "Kommentera"} />;
    $[0] = isPending;
    $[1] = isReply;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t1 || $[4] !== t2) {
    t3 = <RegularButton disabled={t1} testId="comment-submit-btn" type="submit">{t2}</RegularButton>;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== isPending || $[7] !== onCancel) {
    t4 = onCancel ? <button className="px-3 py-2 text-dim text-sm hover:text-charcoal" disabled={isPending} onClick={onCancel} type="button"><Translation da="Annuller" de="Abbrechen" en="Cancel" no="Avbryt" sv="Avbryt" /></button> : null;
    $[6] = isPending;
    $[7] = onCancel;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t3 || $[10] !== t4) {
    t5 = <div className="flex items-center gap-2">{t3}{t4}</div>;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
}